/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import { format } from "date-fns";
import { Label, Checkbox } from "rbx";
import { Link } from "react-router-dom";
import { useCompanyParameters } from "../../../utils/hooks";
import TableCell from "../../../components/TableCell";

export const ITEM_COLUMNS = Auth => {
  const { data: params } = useCompanyParameters();
  let columns = [
    {
      Header: "Item No",
      accessor: "ItemNo",
      sortType: (a, b) => {
        const aVal = a.original.ItemNo;
        const bVal = b.original.ItemNo;
        if (aVal > bVal) return 1;
        if (bVal > aVal) return -1;
        return 0;
      }
    },
    {
      Header: "Description",
      accessor: "Description"
    },
    {
      Header: "Item Category",
      accessor: "ItemCategoryDesc"
    }
  ];
  if (Auth) {
    columns = [
      ...columns,
      {
        Header: "Last Purchase Cost",
        accessor: "LastPurchaseCost",
        Cell: ({ cell }) => <TableCell.Currency value={cell.value} />
      }
    ];
  }
  if (Auth && params?.InventoryCostMethod?.CodeDescription === "Average Cost") {
    columns = [
      ...columns,
      {
        Header: "Average Cost",
        accessor: "AvgCost",
        Cell: ({ cell }) => <TableCell.Currency value={cell.value} />
      }
    ];
  } else if (
    Auth &&
    params?.InventoryCostMethod?.CodeDescription === "Standard Cost"
  ) {
    columns = [
      ...columns,
      {
        Header: "Standard Cost",
        accessor: "StdCost",
        Cell: ({ cell }) => <TableCell.Currency value={cell.value} />
      }
    ];
  }
  if (Auth && params?.AllowMaintenanceBilling) {
    columns = [
      ...columns,
      {
        Header: "List Price",
        accessor: "ListPrice",
        Cell: ({ cell }) => <TableCell.Currency value={cell.value} />
      }
    ];
  }
  return [
    ...columns,
    {
      Header: "Min Qty",
      accessor: "MinQty",
      Cell: ({ cell }) => <TableCell.Number value={cell.value} />
    },
    {
      Header: "Max Qty",
      accessor: "MaxQty",
      Cell: ({ cell }) => <TableCell.Number value={cell.value} />
    },
    {
      Header: "Active",
      accessor: "Active",
      Cell: ({ cell }) => (cell.value ? "Yes" : "No")
    }
  ];
};

export const ITEM_USAGE_COLUMNS = [
  {
    Header: "Month",
    accessor: "Month",
    id: "Month",
    Cell: ({ cell }) => <TableCell.Number value={cell.value} />
  },
  {
    Header: "Year",
    accessor: "Year",
    id: "Year",
    Cell: ({ cell }) => <TableCell.Number value={cell.value} />
  },
  {
    Header: "Qty",
    accessor: "Qty",
    id: "Qty",
    Cell: ({ cell }) => <TableCell.Number value={cell.value} />
  }
];

export const ITEM_TRANSACTION_COLUMNS = [
  {
    Header: "Date",
    id: "Date",
    accessor: "TransDt",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  },
  {
    Header: "Type",
    accessor: "TransactionType",
    Cell: ({ cell }) => (cell.value ? cell.value.CodeDescription : null)
  },
  {
    Header: "Quantity",
    accessor: "Quantity",
    id: "Quantity",
    Cell: ({ cell }) => <TableCell.Number value={cell.value} />
  },
  {
    Header: "Cost",
    accessor: "Cost",
    id: "Cost",
    Cell: ({ cell }) => <TableCell.Currency value={cell.value} />
  },
  {
    Header: "WO No.",
    accessor: "WorkOrder",
    id: "WorkOrder",
    Cell: ({ cell }) => <TableCell.Number value={cell.value} />
  },
  {
    Header: "Vehicle No.",
    accessor: "VehicleRecIdRef",
    id: "VehicleRecIdRef",
    Cell: ({ cell }) => <TableCell.Number value={cell.value} />
  },
  {
    Header: "PO No.",
    accessor: "PONo",
    id: "PONo",
    Cell: ({ cell }) => <TableCell.Number value={cell.value} />
  },
  {
    Header: "Vendor ID",
    accessor: "VendorRecIdRef",
    id: "VendorRecIdRef"
  },
  {
    Header: "Vendor Name",
    accessor: "Vendor",
    Cell: ({ cell }) => (cell.value ? cell.value.Name : null)
  },
  {
    Header: "Created By",
    accessor: "CreatedBy",
    id: "CreatedBy"
  },
  {
    Header: "Created On",
    accessor: "CreatedDateTime",
    Cell: ({ cell }) =>
      cell.value ? format(new Date(cell.value), "MM/dd/yyyy") : null
  }
];

export const VENDORS_COLUMNS = [
  {
    Header: "Primary",
    id: "IsPrimary",
    Cell: ({ row }) => (
      <div>
        <Label>
          <Checkbox
            checked={row.original.IsPrimary}
            defaultChecked={row.original.IsPrimary}
          />
        </Label>
      </div>
    ),
    sortType: (a, b) => {
      const aValue = a.original.IsPrimary;
      const bValue = b.original.IsPrimary;
      if (aValue) return -1;
      if (bValue) return 1;
      return 0;
    }
  },
  {
    Header: "Name",
    accessor: "Vendor.Name",
    id: "VendorName"
  },
  {
    Header: "Number",
    accessor: "Vendor.VendorNo",
    id: "VendorNo",
    Cell: ({ row, cell }) =>
      row?.original?.Vendor?.RecId && cell?.value ? (
        <Link to={`/fleet/vendors/${row.original.Vendor.RecId}/details`}>
          {cell.value}
        </Link>
      ) : null
  },
  {
    Header: "Item No",
    accesor: "VendorItemNo",
    id: "VendorItemNo",
    Cell: ({ row }) => row.original.VendorItemNo
  }
];

export const INVENTORY_ON_HAND_COLUMNS = () => {
  const { data: params } = useCompanyParameters();
  let columns = [
    {
      Header: "Loc",
      accessor: "CompanyLocation.Name",
      id: "CompanyLocRecIdRef"
    }
  ];
  if (params?.UsePrimaryStorageDimension) {
    columns = [
      ...columns,
      {
        Header: params?.PrimaryStorageDimension?.CodeDescription,
        id: "PrimaryStorageDimension",
        Cell: ({ row }) =>
          row.original.InvDim1 ? row.original?.InvDim1?.DimCode : " ",
        sortType: (a, b) => {
          const aVal = String(a.original.InvDim1?.DimCode);
          const bVal = String(b.original.InvDim1?.DimCode);
          if (aVal > bVal) return 1;
          if (bVal > aVal) return -1;
          return 0;
        }
      }
    ];
  }
  if (params?.UseSecondaryStorageDimension) {
    columns = [
      ...columns,
      {
        Header: params?.SecondaryStorageDimension?.CodeDescription,
        id: "SecondaryStorageDimension",
        Cell: ({ row }) =>
          row.original.InvDim2 ? row.original?.InvDim2?.DimCode : " ",
        sortType: (a, b) => {
          const aVal = String(a.original.InvDim2?.DimCode);
          const bVal = String(b.original.InvDim2?.DimCode);
          if (aVal > bVal) return 1;
          if (bVal > aVal) return -1;
          return 0;
        }
      }
    ];
  }
  if (params?.UseTertiaryStorageDimension) {
    columns = [
      ...columns,
      {
        Header: params?.TertiaryStorageDimension?.CodeDescription,
        id: "TertiaryStorageDimension",
        Cell: ({ row }) =>
          row.original.InvDim3 ? row.original?.InvDim3?.DimCode : " ",
        sortType: (a, b) => {
          const aVal = String(a.original.InvDim3?.DimCode);
          const bVal = String(b.original.InvDim3?.DimCode);
          if (aVal > bVal) return 1;
          if (bVal > aVal) return -1;
          return 0;
        }
      }
    ];
  }
  return [
    ...columns,
    {
      Header: "OH",
      accessor: "QtyOnHand",
      id: "QtyOnHand",
      Cell: ({ cell }) => <TableCell.Number value={String(cell.value)} />
    }
  ];
};
